<template lang="pug">
  // アカウント追加完了画面
  #done-execute-add-account
    HeaderForLogin
    b-card.mt-4.text-center.mx-auto.body-width.pb-2(header-tag="header")
      .capiton-box.mx-auto
        // カード内の文言表示
        p.mt-3.white-space {{text_content}}
        router-link.mb-3.d-inline-flex(:to="{name: 'Login'}") ログイン画面へ
</template>

<script>
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";

export default {
  name: "DoneExecuteAddAccount",
  components: {
    HeaderForLogin
  },
  data() {
    return {
      text_content: "クラウド版サポートサイトのアカウント追加が完了しました\n"
          + "下記リンクからログインしてください\n",
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.capiton-box {
  max-width: 600px;
}
.white-space {
  white-space: pre-wrap;
}
</style>